//helpers.js 

// modifiy emails - blanks @mg.b-letter.com and unsubcribes
export function removeun(doc, pubId){
  //console.log('@removeun pubId='+pubId)
  let re = new RegExp(pubId+'@',"g");
  doc=doc.replace(re,'');
  let regex=/mg.b-letter.com/gi
  doc=doc.replace(regex,'')


    //remove any base tag (cdc was problem)
    // console.log('@base')
    let left = doc.indexOf('<base')
    // console.log('@base left='+left);
    if (left>0){
      let pp = doc.indexOf('>',left)+1
      // console.log('@base pp='+pp);
      doc=doc.replace(doc.substring(left,pp),"");
    }

  regex=/mg.b-letter.com/gi
  doc=doc.replace(regex,'')
  //alert('at removeun doc.length='+doc.length)
  regex = /unsubscribe/i;
  let startAt=doc.search(regex);
  while (startAt>0) {
    doc=removeTagWithString(doc,startAt);
    startAt=doc.search(regex);
  }
  return doc
}

const removeTagWithString = function(doc,startAt){
  let left=0 //start of string
  let tag=""
  let endtag="";
  let pp = 0;
  let right=startAt;
  do {			
    left=doc.lastIndexOf('<',right);
    tag=findTagName(doc.substring(left));
    right=left-1;
    endtag="</"+tag+">";
    pp = doc.indexOf(endtag, startAt)+endtag.length;
    //console.log('3 @removeTagWithString tag='+tag+"   test=");
  } while (testEnd(tag,pp,startAt) ) 
  return (doc.replace(doc.substring(left,pp),""));
}





const testEnd = function(x,pp,startAt){
  let permitted= ["style","p","span","div","tr","td"]
  // style because don't want to delete all styles because on has the name unsubscribe or unsubscribe-policy
  //console.log('2 x='+x+"  permitted="+permitted.indexOf(x))
  if (permitted.indexOf(x)==-1) {return true}
  if (x.length>0 && x.charAt(0)=="/") {return false}
  if (pp<startAt){return true}
  return false
}
const findTagName=function(doc){
  let spacePos=doc.indexOf(" ");
  let closingPos=doc.indexOf(">");
  if (spacePos<closingPos){
    //console.log('1 tag='+doc.substring(1,spacePos)+"  DOC="+doc)
    return doc.substring(1,spacePos);
  }else{ //no space, just closing tag (eg <p>)
    //console.log('1 tag='+doc.substring(1,closingPos)+"  -------DOC="+doc)
    return doc.substring(1,closingPos); 
  }
}
export function shortDate(newsletterSecs){
  let newsDate = new Date(newsletterSecs*1000);
  let currentDate = new Date();  //today
  //case of today
  if ((newsDate.getDate()===currentDate.getDate()) || (currentDate.getTime()-newsDate.getTime() < 21600000)){
    // return HH:MM am  HH:MM pm   21600000 is 6 hrs
    let ampm = "am"
    let hours=newsDate.getHours();
    if (hours>12){
      hours=hours-12;
      ampm="pm"
    }
    let minutes=newsDate.getMinutes().toString();
    if (minutes.length<2){
      minutes="0"+minutes;
    }
    return hours+":"+minutes+" "+ampm;
  }
  //case of previous year
  if (newsDate.getFullYear() !== currentDate.getFullYear()){  //— last year and earlier
    // return mm/dd/yy  OR dd/mm/yy
    return newsDate.getMonth()+1+"/"+newsDate.getDate()+"/"+newsDate.getFullYear().toString().substring(2,4)
  }
  // otherwise default to display MMM DD
  return newsDate.toDateString().substring(4,10);
}
